module.exports = __webpack_public_path__ + "img/logo.aa07421b.png";